import DetailedRules from './DetailedRules';

export default (props) => {
  return <DetailedRules {...props} />;
};
